var map = {
	"./logo-alphabet.svg": 531,
	"./logo-amazon-2.svg": 532,
	"./logo-amazon.svg": 565,
	"./logo-azercell.svg": 566,
	"./logo-bank-of-america.svg": 567,
	"./logo-barclays.svg": 568,
	"./logo-bbc.svg": 569,
	"./logo-bloomberg.svg": 533,
	"./logo-bnp-paribas.svg": 570,
	"./logo-booking.svg": 571,
	"./logo-citibank.svg": 572,
	"./logo-cnbc.svg": 534,
	"./logo-cnbc2.svg": 573,
	"./logo-coca-cola-auto.svg": 535,
	"./logo-coca-cola-white.svg": 1475,
	"./logo-coca-cola.svg": 574,
	"./logo-deloitte.svg": 575,
	"./logo-experian.svg": 576,
	"./logo-facebook.svg": 577,
	"./logo-forbes.svg": 536,
	"./logo-g.svg": 1476,
	"./logo-goldman-sachs-new.svg": 578,
	"./logo-goldman-sachs.svg": 1363,
	"./logo-google-new.svg": 579,
	"./logo-google.svg": 580,
	"./logo-h.svg": 581,
	"./logo-henkel.svg": 582,
	"./logo-hsbc-new.svg": 583,
	"./logo-hsbc.svg": 1364,
	"./logo-ikea-new.svg": 584,
	"./logo-ikea.svg": 1477,
	"./logo-infineon.svg": 585,
	"./logo-instagram-icon.svg": 537,
	"./logo-instagram.svg": 586,
	"./logo-jp-morgan.svg": 587,
	"./logo-jti.svg": 588,
	"./logo-linkedin.svg": 589,
	"./logo-meta-new.svg": 538,
	"./logo-meta.svg": 1365,
	"./logo-morgan-stanley-new.svg": 590,
	"./logo-morgan-stanley.svg": 1366,
	"./logo-netflix.svg": 1367,
	"./logo-oracle.svg": 539,
	"./logo-paypal.svg": 591,
	"./logo-pwc-new.svg": 540,
	"./logo-pwc.svg": 1478,
	"./logo-spotify.svg": 1368,
	"./logo-tesla.svg": 592,
	"./logo-usa-today.svg": 541,
	"./logo-visa.svg": 593,
	"./logo-walmart.svg": 542,
	"./logo-wsj.svg": 543,
	"./logo-youtube.svg": 594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;